/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Gazdetectiondefect2Inputs */



/**
* | output |
* | --- |
* | "Ambient air gas detection sensor" |
*
* @param {Br_History_Key_Gazdetectiondefect2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_gazdetectiondefect2 = /** @type {((inputs?: Br_History_Key_Gazdetectiondefect2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Gazdetectiondefect2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ambient air gas detection sensor")
	return /** @type {LocalizedString} */ ("Capteur de détection de gaz dans l'air ambiant")
});
export { br_history_key_gazdetectiondefect2 as "br_history_key_gazDetectionDefect" }